export const getColor=(str)=>{
  switch(str) {
      case 'Amis':
          return '#07d7f6'
      case 'Equipement':
          return '#dba2e6'
      case 'Famille':
          return '#2ca1ae'
      case 'Maison':
          return '#77ecca'
      case 'Perso':
          return '#48A868'
      case 'Travail':
          return '#ae91e2'
      default: 
          return '#59719C'
  }

}